import type { ImageBleed } from 'types';
import type { ImageGridModule } from 'types/capi/article';

import { ImageGridCore } from '~/modules/ste/ImageGrid';
import { getBleedClass } from '~/modules/ste/ModuleRow';

type Props = {
  bleed: ImageBleed;
  module: ImageGridModule;
  numColumns: number;
};

export default function EmbeddedImageGrid({
  bleed,
  module,
  numColumns
}: Props) {
  const bleedClass = getBleedClass(bleed, numColumns);

  return (
    <div className={bleedClass}>
      <ImageGridCore items={module.items} bleed={bleed} />
    </div>
  );
}
